import '../pages.css';
import { Link } from 'react-router-dom';

const Emax = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/fixed" className="back-link">← Back to Fixed Prosthetics</Link>
                    <h1>IPS e.max®</h1>
                    <p className="product-tagline">The gold standard for esthetic ceramic dentistry</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            IPS e.max® restorations from <strong>AbELab</strong> are fabricated from lithium disilicate glass-ceramic and
                            can be produced as monolithic or layered restorations. With multiple translucency levels and flexural strength
                            up to 500 MPa, IPS e.max remains the gold standard for esthetic ceramic dentistry.
                        </p>
                    </div>

                    <div className="product-two-column">
                        <div className="product-section">
                            <h2>Indications</h2>
                            <ul>
                                <li>Anterior esthetic restorations</li>
                                <li>Posterior crowns requiring both strength and beauty</li>
                            </ul>
                        </div>

                        <div className="product-section">
                            <h2>Contraindications</h2>
                            <ul>
                                <li>Bridges involving molars</li>
                                <li>Maryland-style bridges</li>
                                <li>Short vertical height cases with inadequate connector dimensions</li>
                            </ul>
                        </div>
                    </div>

                    <div className="product-section">
                        <h2>Preparation</h2>

                        <h3>Anterior Crowns</h3>
                        <ul>
                            <li>Chamfer or shoulder margin (1 mm width)</li>
                            <li>Facial reduction: 1.5–2 mm</li>
                            <li>Lingual reduction: 1–1.5 mm</li>
                            <li>Incisal reduction: 1.5–2 mm</li>
                        </ul>

                        <h3>Posterior Crowns</h3>
                        <ul>
                            <li>Chamfer or shoulder margin (1 mm)</li>
                            <li>Occlusal reduction: 1.5–2 mm</li>
                            <li>Axial reduction: 1.5 mm</li>
                        </ul>
                    </div>

                    <div className="product-section">
                        <h2>Cementation</h2>
                        <ul>
                            <li>Resin-reinforced glass ionomer (RelyX™ Luting)</li>
                            <li>Resin cement (RelyX™ Unicem / Ultimate) when additional retention is required</li>
                        </ul>
                    </div>

                    <div className="product-section">
                        <h2>Technical Notes</h2>
                        <p>Use fine diamonds with water and minimal pressure.</p>
                        <p>Adjust restorations off the tooth whenever possible.</p>
                    </div>

                    <div className="product-section product-codes">
                        <h2>Codes</h2>
                        <ul>
                            <li><strong>D2740</strong> – Crown</li>
                            <li><strong>D2610</strong> – Inlay, 1 surface</li>
                            <li><strong>D2620</strong> – Inlay, 2 surfaces</li>
                            <li><strong>D2630</strong> – Inlay, 3 surfaces</li>
                            <li><strong>D2962</strong> – Labial veneer</li>
                            <li><strong>D2783</strong> – ¾ crown, porcelain/ceramic</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Emax;
